export interface BriefingBranchConfig {
  location: string;
  branchName: string;
  pageTitle: string;
  eventISO: string;

  eventDateMeta: string;
  eventDateFull: string;
  eventDateMobile: string;

  metaPlaceLine1Pc: string;
  metaPlaceLine2Pc: string;
  metaPlaceLine1Mobile: string;
  metaPlaceLine2Mobile: string;

  heroEyebrowPc: string;
  heroEyebrowMobile: string;
  heroTagline: string;

  infoCardAddressPc: string;
  infoCardAddressMobile: string;

  benefitRegistrationText: string;

  fixedBarText: string;
  fixedBarIntroLabel: string;
  introduceLocationKey: string;
  telHref: string;
  kakaoUrl: string;

  mixpanelPageType: string;
  formType: string;

  totalOffset: number;
  last24hOffset: number;
}

export const DONGTAN_CONFIG: BriefingBranchConfig = {
  location: 'dongtan',
  branchName: '동탄점',
  pageTitle: '수능선배 동탄점 설명회',
  eventISO: '2026-06-20T00:00:00+09:00',

  eventDateMeta: '2026. 06. 20 (토)',
  eventDateFull: '2026년 06월 20일 (토)',
  eventDateMobile: '2026.06.20 (토)',

  metaPlaceLine1Pc: '수능선배 동탄점 4층',
  metaPlaceLine2Pc: '경기 화성시 동탄구 메타폴리스로 42',
  metaPlaceLine1Mobile: '동탄점 4층',
  metaPlaceLine2Mobile: '화성시 메타폴리스로 42',

  heroEyebrowPc: 'OFF THE RECORD\n수능선배 동탄점 설명회',
  heroEyebrowMobile: 'OFF THE RECORD\n수능선배 동탄점\n설명회',
  heroTagline: '대치동 1등 독학재수학원 시스템 그대로, 이제 동탄에서',

  infoCardAddressPc: '수능선배 동탄점 (경기도 화성시 동탄구 메타폴리스로 42 4층)',
  infoCardAddressMobile: '수능선배 동탄점 (화성시 메타폴리스로 42, 4F)',

  benefitRegistrationText: '수능선배 동탄점\n등록비 지원',

  fixedBarText: '대치동 1등 독학재수학원\n수능선배 동탄점 설명회 신청',
  fixedBarIntroLabel: '동탄점 소개',
  introduceLocationKey: '동탄',
  telHref: 'tel://16685786',
  kakaoUrl: 'http://pf.kakao.com/_Whxexgxj/chat',

  mixpanelPageType: 'briefing_dongtan',
  formType: 'briefing_dongtan',

  totalOffset: 150,
  last24hOffset: 5,
};

export const GANGDONG_CONFIG: BriefingBranchConfig = {
  location: 'gangdong',
  branchName: '강동점',
  pageTitle: '수능선배 강동점 설명회',
  eventISO: '2026-06-21T00:00:00+09:00',

  eventDateMeta: '2026. 06. 21 (일)',
  eventDateFull: '2026년 06월 21일 (일)',
  eventDateMobile: '2026.06.21 (일)',

  metaPlaceLine1Pc: '수능선배 강동점 10층',
  metaPlaceLine2Pc: '서울 강동구 양재대로 1465',
  metaPlaceLine1Mobile: '강동점 10층',
  metaPlaceLine2Mobile: '강동구 양재대로 1465',

  heroEyebrowPc: 'OFF THE RECORD\n수능선배 강동점 설명회',
  heroEyebrowMobile: 'OFF THE RECORD\n수능선배 강동점\n설명회',
  heroTagline: '대치동 1등 독학재수학원 시스템 그대로, 이제 강동에서',

  infoCardAddressPc: '수능선배 강동점 (서울특별시 강동구 양재대로 1465 10층 1001호)',
  infoCardAddressMobile: '수능선배 강동점 (강동구 양재대로 1465, 10F 1001호)',

  benefitRegistrationText: '수능선배 강동점\n등록비 지원',

  fixedBarText: '대치동 1등 독학재수학원\n수능선배 강동점 설명회 신청',
  fixedBarIntroLabel: '강동점 소개',
  introduceLocationKey: '강동',
  telHref: 'tel://16685786',
  kakaoUrl: 'http://pf.kakao.com/_Whxexgxj/chat',

  mixpanelPageType: 'briefing_gangdong',
  formType: 'briefing_gangdong',

  totalOffset: 50,
  last24hOffset: 5,
};

export const GIMPO_CONFIG: BriefingBranchConfig = {
  location: 'gimpo',
  branchName: '김포점',
  pageTitle: '수능선배 김포점 설명회',
  eventISO: '2026-06-28T00:00:00+09:00',

  eventDateMeta: '2026. 06. 28 (일)',
  eventDateFull: '2026년 06월 28일 (일)',
  eventDateMobile: '2026.06.28 (일)',

  metaPlaceLine1Pc: '수능선배 김포점 4층',
  metaPlaceLine2Pc: '경기 김포시 사우중로 49',
  metaPlaceLine1Mobile: '김포점 4층',
  metaPlaceLine2Mobile: '김포시 사우중로 49',

  heroEyebrowPc: 'OFF THE RECORD\n수능선배 김포점 설명회',
  heroEyebrowMobile: 'OFF THE RECORD\n수능선배 김포점\n설명회',
  heroTagline: '대치동 1등 독학재수학원 시스템 그대로, 이제 김포에서',

  infoCardAddressPc: '수능선배 김포점 (경기도 김포시 사우중로 49 4층)',
  infoCardAddressMobile: '수능선배 김포점 (김포시 사우중로 49, 4F)',

  benefitRegistrationText: '수능선배 김포점\n등록비 지원',

  fixedBarText: '대치동 1등 독학재수학원\n수능선배 김포점 설명회 신청',
  fixedBarIntroLabel: '김포점 소개',
  introduceLocationKey: '김포',
  telHref: 'tel://16685786',
  kakaoUrl: 'http://pf.kakao.com/_Whxexgxj/chat',

  mixpanelPageType: 'briefing_gimpo',
  formType: 'briefing_gimpo',

  totalOffset: 50,
  last24hOffset: 5,
};

export const HANAM_CONFIG: BriefingBranchConfig = {
  location: 'hanam',
  branchName: '하남점',
  pageTitle: '수능선배 하남점 설명회',
  eventISO: '2026-07-05T00:00:00+09:00',

  eventDateMeta: '2026. 07. 05 (일)',
  eventDateFull: '2026년 07월 05일 (일)',
  eventDateMobile: '2026.07.05 (일)',

  metaPlaceLine1Pc: '수능선배 하남점 4층',
  metaPlaceLine2Pc: '경기 하남시 미사강변대로54번길 33',
  metaPlaceLine1Mobile: '하남점 4층',
  metaPlaceLine2Mobile: '하남시 미사강변대로54번길 33',

  heroEyebrowPc: 'OFF THE RECORD\n수능선배 하남점 설명회',
  heroEyebrowMobile: 'OFF THE RECORD\n수능선배 하남점\n설명회',
  heroTagline: '대치동 1등 독학재수학원 시스템 그대로, 이제 하남에서',

  infoCardAddressPc: '수능선배 하남점 (경기도 하남시 미사강변대로54번길 33 4층)',
  infoCardAddressMobile: '수능선배 하남점 (하남시 미사강변대로54번길 33, 4F)',

  benefitRegistrationText: '수능선배 하남점\n등록비 지원',

  fixedBarText: '대치동 1등 독학재수학원\n수능선배 하남점 설명회 신청',
  fixedBarIntroLabel: '하남점 소개',
  introduceLocationKey: '하남',
  telHref: 'tel://16685786',
  kakaoUrl: 'http://pf.kakao.com/_Whxexgxj/chat',

  mixpanelPageType: 'briefing_hanam',
  formType: 'briefing_hanam',

  totalOffset: 50,
  last24hOffset: 5,
};
